import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, ValidatorFn, FormControl, Validators } from '@angular/forms';
import { pass } from 'src/app/@compartido/valid-pattern';
import { UserService } from '../../services/user-service.service';
import { NotificacionesService } from 'src/app/services/notificaciones.service';

@Component({
  selector: 'app-modal-cambio-password',
  templateUrl: './modal-cambio-password.component.html',
  styleUrls: ['./modal-cambio-password.component.scss']
})
export class ModalCambioPasswordComponent implements OnInit {

  form: FormGroup;
  hide = true;
  hideDos = true;
  hideTres = true;
  existeError = null;
  constructor(public dialogRef: MatDialogRef<ModalCambioPasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private notificacionesService: NotificacionesService,
    private servicio: UserService) { }

  ngOnInit() {
    this.crearForm();
  }

  crearForm() {
    this.form = new FormGroup({
      passAnterio: new FormControl(null, [Validators.required]),
      newPassword: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(32),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$%#&.-])[A-Za-z0-9@$%#&.-]{8,32}$')

      ]),
      confirmacion: new FormControl(null, [
        Validators.required,
        Validators.minLength(8),
        Validators.maxLength(32),
        Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[@$%#&.-])[A-Za-z0-9@$%#&.-]{8,32}$')
      ]),
    }, [this.validacionPass()]);
  }

  validacionPass(): ValidatorFn {
    return (group: FormGroup): { [key: string]: boolean } | null => {
      const TB = group.value;
      if (TB.newPassword !== TB.confirmacion) return { 'noIguales': true };
      return null;
    };
  }
  cambiarPass() {
    let body = {
      loginName: this.data.username,
      oldPassword: this.form.get('passAnterio').value,
      newPassword: this.form.get('newPassword').value
    }
    this.servicio.changePassword(body).subscribe(resp => {
      if (!resp.resultado.exito) return this.notificacionesService.snackbarAviso('Hubo un problema al cambiar su contraseña.', 'X');
      this.dialogRef.close(true);
      this.notificacionesService.snackbarAviso('El cambio de contraseña fue exitoso.', 'X');
    }, err => {
      this.dialogRef.close(true);
      this.notificacionesService.snackbarAviso('Hubo un problema al cambiar su contraseña.', 'X');
    });
  }
}
